import { caseStatusApiSchema } from "@/components/Forms/schema/caseStatusSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceCollectionSelector } from "jsonapi-zod-query";

const caseStatusSelector = createResourceCollectionSelector({
    type: "caseStatus",
    attributesSchema: caseStatusApiSchema,
});

export type CaseStatus = ReturnType<typeof caseStatusSelector>;

export const useFetchCaseStatuses = (): UseQueryResult<CaseStatus> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["case-status"],
        queryFn: async ({ signal }) => {
            const url = apiUrl("/case-status/get-all");

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: caseStatusSelector,
    });
};
